export default __webpack_public_path__ + "0795f7433f0b0573f8e522b91bae0c57.svg";